"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactDesc = require("react-desc"); // @ts-ignore no module typings


var schema = (0, _reactDesc.describe)({
  displayName: 'Wizard'
});
schema.propTypes = {
  id: _reactDesc.PropTypes.string.description('A unique identifier for the modal.'),
  size: _reactDesc.PropTypes.oneOf(['normal', 'extraLarge']).description('Define the max width size of the modal').defaultValue('normal'),
  title: _reactDesc.PropTypes.string.description('The text for rendering in the H2 at the top of the modal').isRequired,
  onCancel: _reactDesc.PropTypes.func.description('The event handler called to close the modal. This is called by either pressing Esc or clicking the "Cancel" button').isRequired,
  visible: _reactDesc.PropTypes.bool.description('A boolean value used to control whether the modal is visible or not').defaultValue('false'),
  zIndex: _reactDesc.PropTypes.number.description('Sets the z-index value for the modal & overlay.'),
  activeStep: _reactDesc.PropTypes.number.description('The currently active step in the wizard. This has to be handled by the user').isRequired,
  steps: _reactDesc.PropTypes.arrayOf(_reactDesc.PropTypes.shape({
    title: _reactDesc.PropTypes.string.isRequired,
    content: _reactDesc.PropTypes.node.isRequired,
    previousButtonProps: _reactDesc.PropTypes.shape({
      onClick: _reactDesc.PropTypes.func.isRequired
    }),
    nextButtonProps: _reactDesc.PropTypes.shape({
      onClick: _reactDesc.PropTypes.func.isRequired
    })
  })).description('Define the steps to render in the wizard. For more info on the usage, see the Step Props table below').isRequired,
  submitButtonProps: _reactDesc.PropTypes.shape({
    onClick: _reactDesc.PropTypes.func.isRequired
  }).description('the props to pass to the submit button, this button is rendered by default in the last stesp').isRequired
};
var _default = schema;
exports.default = _default;